// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getIsRecapchaEnabled,
  getNewGlobalErrorMessage,
  getPlccOfferPercentage,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  renderLabel,
  getLabelFromCopyOrFromTranslation,
} from '@tcp/core/src/utils/labels/labelUtilty';
import ApplyNowModalPLCCReducer from '@tcp/core/src/components/common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.reducer';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import ApplyCardReducer from '@tcp/core/src/components/features/browse/ApplyCardPage/container/ApplyCard.reducer';
import {
  ApplyCreditCardSaga,
  SubmitInstantCardApplication,
} from '@tcp/core/src/components/features/browse/ApplyCardPage/container/ApplyCard.saga';
import { replaceText } from '@tcp/core/src/utils/utils';
import labelsObj from '@tcp/core/src/components/features/account/Payment/Payment.labels';
import { compose } from 'redux';
import {
  getCardList,
  setDeleteModalMountedState,
  deleteCard,
  checkBalance,
  setDefaultPayment,
  setPaymentNotification,
  fetchModuleX,
} from './Payment.actions';
import { resetSuccessState } from '../../AddEditCreditCard/container/AddEditCreditCard.actions';

import {
  getCreditDebitCards,
  getCardListFetchingState,
  getShowNotificationState,
  deleteModalOpenState,
  showUpdatedNotificationOnModalState,
  getGiftCards,
  getVenmoCards,
  getCardListState,
  checkbalanceValue,
  getShowNotificationCaptchaState,
  getPaymentBannerContentId,
  getPaymentBannerRichTextSelector,
} from './Payment.selectors';
import PaymentView from '../views/PaymentView';
import CardViewSkeleton from '../skeleton/CardViewSkeleton.view';

import utils from '../../../../../utils';
import { getPLCCDiscountValue } from '../../../../common/organisms/Promotions/container/Promotions.selectors';
import GlobalErrorComponentReducer from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.reducer';
import {
  hideError,
  setGlobalError,
  setModalError,
} from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';
import {
  getErrorMessage,
  getErrorModalVisibleState,
  getErrorVisibleState,
} from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.selectors';

export class PaymentContainer extends React.Component {
  constructor(props) {
    super(props);

    this.paymentGCLabels =
      getLabelFromCopyOrFromTranslation('account.paymentGC', labelsObj) ||
      labelsObj.account.paymentGC;
  }

  componentDidMount() {
    const { getCardListAction, paymentBannerContentId, getPaymentBannerRichText } = this.props;
    getCardListAction();
    getPaymentBannerRichText(paymentBannerContentId);
  }

  componentDidUpdate() {
    const {
      setGlobalErrorAction,
      showGlobalError,
      showUpdatedNotificationOnModal,
      isErrorModalVisibleState,
      setModalErrorAction,
      clearPaymentNotification,
      errorMessageGlobalComp,
      newGlobalErrorMessageEnabled,
      showNotification,
    } = this.props;
    if (newGlobalErrorMessageEnabled) {
      if (showGlobalError && !errorMessageGlobalComp) {
        const errMsg = renderLabel(
          this.paymentGCLabels.lbl_payment_errorMsg,
          'lbl_payment_errorMsg'
        );
        setGlobalErrorAction({ message: errMsg, type: 'error' });
      }
      if (showNotification === 'success') {
        clearPaymentNotification();
        const successMsg = renderLabel(
          this.paymentGCLabels.lbl_payment_successMsg,
          'lbl_payment_successMsg'
        );
        setGlobalErrorAction({ message: successMsg, type: 'success' });
      }

      if (showUpdatedNotificationOnModal && isErrorModalVisibleState) {
        setModalErrorAction({
          message: renderLabel(this.paymentGCLabels.lbl_payment_errorMsg, 'lbl_payment_errorMsg'),
          type: showUpdatedNotificationOnModal,
        });
      }
    }
  }

  componentWillUnmount() {
    const { clearPaymentNotification, resetSuccessNotification, hideErrorAction } = this.props;
    clearPaymentNotification();
    resetSuccessNotification();
    hideErrorAction();
  }

  addNewCreditCard = () => {
    utils.routerPush(
      '/account?id=payment&subSection=add-credit-card',
      '/account/payment/add-credit-card'
    );
  };

  render() {
    const {
      showNotification,
      setDeleteModalMountState,
      deleteModalMountedState,
      onDeleteCard,
      showUpdatedNotificationOnModal,
      creditCardList,
      giftCardList,
      venmoCardList,
      cardList,
      onGetBalanceCard,
      checkbalanceValueInfo,
      setDefaultPaymentMethod,
      showNotificationCaptcha,
      paymentBannerRichText,
      plccOfferPercentage,
      isFetching,
      isRecapchaEnabled,
      newGlobalErrorMessageEnabled,
    } = this.props;

    const placeholderValue = '#plccOfferPercentage#';

    const updatedPaymentBannerRichText = replaceText(
      paymentBannerRichText,
      placeholderValue,
      'b#plccOfferText',
      plccOfferPercentage
    );

    const updatedLabels = { ACC_PAYMNET_BANNER_LABEL: updatedPaymentBannerRichText };

    if (isFetching) {
      return <CardViewSkeleton />;
    }
    return (
      <PaymentView
        deleteModalMountedState={deleteModalMountedState}
        setDeleteModalMountState={setDeleteModalMountState}
        showNotification={showNotification}
        showNotificationCaptcha={showNotificationCaptcha}
        onDeleteCard={onDeleteCard}
        showUpdatedNotificationOnModal={showUpdatedNotificationOnModal}
        labels={updatedLabels}
        creditCardList={creditCardList}
        giftCardList={giftCardList}
        venmoCardList={venmoCardList}
        cardList={cardList}
        onGetBalanceCard={onGetBalanceCard}
        checkbalanceValueInfo={checkbalanceValueInfo}
        setDefaultPaymentMethod={setDefaultPaymentMethod}
        addCreditCard={this.addNewCreditCard}
        isRecapchaEnabled={isRecapchaEnabled}
        plccOfferPercentage={plccOfferPercentage}
        newGlobalErrorMessageEnabled={newGlobalErrorMessageEnabled}
      />
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    getCardListAction: () => {
      dispatch(getCardList({ ignoreCache: true }));
    },
    setDeleteModalMountState: (payload) => {
      dispatch(setDeleteModalMountedState(payload));
    },
    onDeleteCard: (payload) => {
      dispatch(deleteCard(payload));
    },
    onGetBalanceCard: (payload) => {
      dispatch(checkBalance(payload));
    },
    setDefaultPaymentMethod: (payload) => {
      dispatch(setDefaultPayment(payload));
    },
    clearPaymentNotification: () => {
      dispatch(
        setPaymentNotification({
          status: '',
        })
      );
    },
    getPaymentBannerRichText: (cid) => {
      dispatch(fetchModuleX(cid));
    },
    resetSuccessNotification: () => {
      dispatch(resetSuccessState());
    },
    setGlobalErrorAction: (payload) => {
      dispatch(setGlobalError(payload));
    },
    hideErrorAction: (payload) => {
      dispatch(hideError(payload));
    },
    setModalErrorAction: (payload) => {
      dispatch(setModalError(payload));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    cardList: getCardListState(state),
    creditCardList: getCreditDebitCards(state),
    giftCardList: getGiftCards(state),
    venmoCardList: getVenmoCards(state),
    isFetching: getCardListFetchingState(state),
    showNotification: getShowNotificationState(state),
    showNotificationCaptcha: getShowNotificationCaptchaState(state),
    deleteModalMountedState: deleteModalOpenState(state),
    showUpdatedNotificationOnModal: showUpdatedNotificationOnModalState(state),
    checkbalanceValueInfo: checkbalanceValue(state),
    paymentBannerContentId: getPaymentBannerContentId(),
    paymentBannerRichText: getPaymentBannerRichTextSelector(state),
    isRecapchaEnabled: getIsRecapchaEnabled(state),
    plccOfferPercentage: getPLCCDiscountValue(state) || getPlccOfferPercentage(state),
    newGlobalErrorMessageEnabled: getNewGlobalErrorMessage(state),
    showGlobalError: getErrorVisibleState(state),
    isErrorModalVisibleState: getErrorModalVisibleState(state),
    errorMessageGlobalComp: getErrorMessage(state),
  };
};

PaymentContainer.defaultProps = {
  clearPaymentNotification: null,
  isFetching: false,
};

PaymentContainer.propTypes = {
  getCardListAction: PropTypes.func.isRequired,
  showNotification: PropTypes.string.isRequired,
  deleteModalMountedState: PropTypes.bool.isRequired,
  setDeleteModalMountState: PropTypes.func.isRequired,
  onDeleteCard: PropTypes.func.isRequired,
  showUpdatedNotificationOnModal: PropTypes.string.isRequired,
  creditCardList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  venmoCardList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  giftCardList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cardList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onGetBalanceCard: PropTypes.func.isRequired,
  checkbalanceValueInfo: PropTypes.string.isRequired,
  setDefaultPaymentMethod: PropTypes.func.isRequired,
  getPaymentBannerRichText: PropTypes.func.isRequired,
  paymentBannerContentId: PropTypes.string.isRequired,
  showNotificationCaptcha: PropTypes.bool.isRequired,
  paymentBannerRichText: PropTypes.string.isRequired,
  clearPaymentNotification: PropTypes.func,
  resetSuccessNotification: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  isRecapchaEnabled: PropTypes.bool.isRequired,
};

const withReducer = withDynamicReducer([
  { key: 'ApplyNowModal', reducer: ApplyNowModalPLCCReducer },
  { key: 'GlobalErrorComponent', reducer: GlobalErrorComponentReducer },
  { key: 'ApplyCardPage', reducer: ApplyCardReducer },
]);
const withSaga = useDynamicSaga([
  { key: 'ApplyCardPage', saga: ApplyCreditCardSaga },
  { key: 'ApplyCardPageSaga', saga: SubmitInstantCardApplication },
]);

export default compose(
  withReducer,
  withSaga,
  connect(mapStateToProps, mapDispatchToProps)
)(PaymentContainer);
